<template>
  <div class="feedback_container">
    <div class="downLoadInfo">
      <div v-if="showDownLoadIcon" class="download item_box" @click="handleDownLoad" />
    </div>
    <!-- 指引按钮 -->
    <el-popover
      ref="menuPopover"
      popper-class="el-popover-scoped"
      placement="left-end"
      width="112"
      trigger="hover"
      @hide="handleHide"
      @after-enter="handleShow"
    >
      <el-menu
        class="el-menu-scoped"
        default-active="-1"
        textColor="#2E2F33"
        activeTextColor="#2E2F33"
        @select="handleClickMenu"
      >
        <el-menu-item
          v-for="(item, index) in menuList"
          :key="index"
          :index="index + ''"
          :class="qrEnter && item.type === 'question' ? 'el-menu-item-hover' : ''"
          :data-type="item.type"
        >
          <el-popover
            v-if="item.type === 'question'"
            popper-class="el-popover-scoped sec"
            placement="left-end"
            width="150"
            trigger="hover"
            :offset="-40 * (menuList.length - 1 - index)"
            @show="handleSubShow"
            @hide="handleSubHide"
          >
            <div class="QR-code-area" @mouseenter="handleQrEnter" @mouseleave="handleQrLeave">
              <img class="QR-img" :src="QQinfo.qqGroupRq" alt="" />
              <div>群名称: {{ QQinfo.qqGroupName }}</div>
              <div>群号: {{ QQinfo.qqGroupNum }}</div>
            </div>

            <div class="el-menu-item-area" slot="reference">
              <div :class="['menu-item-icon', item.icon]" />
              <div class="navinfo navInline " slot="title">
                {{ item.lable }}
              </div>
            </div>
          </el-popover>

          <section v-else class="el-menu-item-area">
            <div :class="['menu-item-icon', item.icon]" />
            <div class="navinfo" slot="title">
              {{ item.lable }}
            </div>
          </section>
        </el-menu-item>
      </el-menu>
      <div
        slot="reference"
        :class="[
          showDownLoadIcon ? 'item_box_menu item_box_menu_fixed' : 'item_box_menu',
          menuListEnter || qrEnter ? 'item_box_menu_hover' : ''
        ]"
      />
    </el-popover>
    <!-- 弹出框 -->
    <el-dialog custom-class="el-dialog-scoped" :visible.sync="dialogFormVisible" @closed="setLoadingStatus">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="问题反馈" name="feedback">
          <div class="description">
            <span> *</span>
            <span> 问题类型（可多选）</span>
          </div>
          <el-checkbox-group v-model="checkboxGroup" @change="changeCheckbox">
            <el-checkbox-button v-for="type in questionTypes" :label="type.id" :key="type.id">
              {{ type.text }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-tab-pane>

        <el-tab-pane label="产品建议" name="advice"> </el-tab-pane>

        <div :class="adviceTextarea ? 'textareaContainer adviceTextareaContainer' : 'textareaContainer'">
          <el-input
            type="textarea"
            placeholder="请详细描述您在使用中遇到的问题或改进建议（至少10个字符）"
            v-model="details"
            maxlength="200"
            minlength="10"
            :class="adviceTextarea ? 'adviceTextarea' : ''"
            show-word-limit
            resize="none"
            @blur="checkTextLength"
            @input="changeStatus"
          />
        </div>

        <div class="error">
          {{ errorText }}
        </div>

        <div
          :class="adviceScreenshot ? 'screenshot adviceScreenshot' : 'screenshot'"
          v-loading="loading"
          element-loading-text="正在生成当前页面截图"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#FFF"
          @click="alertScreenShot"
        >
          <img class="canvas" />
          <div class="mask" />
          <div :class="dialogScreenshotVisible ? 'screenshotAlert' : 'screenshotAlert screenshotAlertHide'">
            <i class="close" @click="alertScreenShot" />
            <img />
          </div>
        </div>

        <div class="browserTips">
          建议使用<span>Chrome</span>浏览器访问，获得更好的产品使用体验
        </div>

        <el-button type="primary" round :disabled="!canSubmit" @click="submit">
          提交
        </el-button>
      </el-tabs>
    </el-dialog>

    <div :class="alertShow ? 'alert alertShow' : 'alert'" v-html="alert" />
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import axios from 'axios'
import qs from 'qs'
import api from '@/services/invite/index'
import request from '@/services/request'

import { xssCheck } from '../utils/common'
export default {
  name: 'FeedBack',

  props: {
    // 是否展示下载按钮
    showDownLoadIcon: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.getMyOrgInfo()
  },

  data() {
    return {
      dialogFormVisible: false,
      activeName: 'feedback',
      checkboxGroup: [],
      // id无序原因：rd要求id跟公共版一致(http://confluence.inner.youdao.com/pages/viewpage.action?pageId=84634995)，pm要求顺序，
      questionTypes: [
        {
          id: 5,
          text: '注册登录'
        },
        {
          id: 1,
          text: '翻译质量'
        },
        {
          id: 3,
          text: '预览异常'
        },
        {
          id: 2,
          text: '上传下载'
        },
        {
          id: 7,
          text: '术语库'
        },
        {
          id: 8,
          text: '其他'
        }
      ],
      menuList: [
        {
          lable: '用户问卷',
          icon: 'ic_survey',
          type: 'survey',
          url: 'https://survey.163.com/htmls/guxa23/paper.html'
        },
        {
          lable: '意见反馈',
          icon: 'ic_feedback',
          type: 'feedback'
        },
        {
          lable: '官方答疑',
          icon: 'ic_question',
          type: 'question'
        },
        {
          lable: '使用指南',
          icon: 'ic_handbook',
          type: 'handbook'
        }
      ],
      details: '',
      adviceTextarea: false,
      adviceScreenshot: false,
      lastCheckLength: 0,
      errorText: '',
      feedbackType: 0,
      canSubmit: false,
      screenshot: '',
      loading: true,
      alert: '',
      alertShow: false,
      dialogScreenshotVisible: false,
      QQinfo: {
        qqGroupName: '',
        qqGroupNum: '',
        qqGroupRq: ''
      },
      menuEnter: false,
      menuListEnter: false,
      qrEnter: false
    }
  },

  methods: {
    alertScreenShot(e) {
      this.dialogScreenshotVisible = !this.dialogScreenshotVisible
      document.querySelector('.screenshotAlert img').src = this.screenshot
      e.stopPropagation()
    },

    setLoadingStatus() {
      this.loading = true
      this.dialogScreenshotVisible = false
      // 防止任务详情页截图失败
      document.body.style.height = 'auto'
      document.getElementsByTagName('html')[0].style.height = 'auto'
      document.getElementById('app').style.height = 'auto'
    },

    handleClick() {
      const that = this
      this.dialogFormVisible = true
      if (document.querySelectorAll('.screenshot')[0]) {
        document
          .querySelectorAll('.screenshot')[0]
          .querySelector('img')
          .setAttribute('src', '')
      }
      // 防止任务详情页截图失败
      document.body.style.height = '100%'
      document.getElementsByTagName('html')[0].style.height = '100%'
      document.getElementById('app').style.height = '100vh'
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      html2canvas(document.body, {
        height: document.body.scrollHeight,
        width: document.body.scrollWidth,
        useCORS: true,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        scrollY: -scrollTop,
        onrendered: function(canvas) {
          document.body.appendChild(canvas)
          window.scrollTo(0, scrollTop)
        }
      }).then(canvas => {
        setTimeout(() => {
          that.screenshot = canvas.toDataURL('image/jpeg')
          document.querySelector('.canvas').setAttribute('src', this.screenshot)
          that.loading = false
        }, 0)
      })
    },

    changeStatus() {
      this.canSubmit = false
      if (this.details.length >= 10) {
        this.errorText = ''
        if ((this.feedbackType === 0 && this.checkboxGroup.length) || this.feedbackType === 1) {
          this.canSubmit = true
        }
      }
      if (this.details.length === 200) {
        document.querySelector('.el-input__count').style.color = '#FF6583'
      } else {
        document.querySelector('.el-input__count').style.color = ''
      }
    },

    handleTabClick(tab, event) {
      if (tab.index === '0') {
        this.adviceTextarea = false
        this.adviceScreenshot = false
        this.feedbackType = 0
      } else {
        this.adviceTextarea = true
        this.adviceScreenshot = true
        this.checkboxGroup = []
        this.lastCheckLength = 0
        this.feedbackType = 1
      }
      this.changeStatus()
    },

    changeCheckbox(values) {
      if (this.lastCheckLength === 0 && values.length === 1) {
        const textarea = document.querySelector('.textareaContainer')
        setTimeout(() => {
          textarea.style.border = '1px solid #2962FF'
        }, 400)
        setTimeout(() => {
          textarea.style.border = '1px solid #EBECF0'
        }, 1400)
      }
      this.lastCheckLength = values.length
      this.changeStatus()
    },

    checkTextLength() {
      if (this.details.length < 10) {
        this.errorText = '请输入至少10个字符'
      } else {
        this.errorText = ''
      }
      this.changeStatus()
    },

    submit() {
      const UAParser = require('ua-parser-js')
      const parser = new UAParser()
      let browserNameEndVersion = parser.getBrowser()
      browserNameEndVersion = browserNameEndVersion.name
        ? browserNameEndVersion.name + browserNameEndVersion.version
        : window.navigator.userAgent
      const that = this
      const details = xssCheck(this.details)
      if (this.canSubmit && !this.hasSubmit) {
        this.hasSubmit = true
        request({
          url: '/feedback/add',
          method: 'post',
          data: {
            feedbackType: this.feedbackType,
            questionType: this.checkboxGroup.toString(),
            screenshot: this.screenshot,
            client: browserNameEndVersion,
            details
          }
        })
          .then(data => {
            that.dialogFormVisible = false
            that.alertShow = true
            if (parseInt(data.errorCode, 10) === 0) {
              that.alert = '提交成功！<br>我们会尽快评估并处理'
              that.checkboxGroup = []
              that.details = ''
            } else {
              that.alert = '提交失败'
            }
            setTimeout(() => {
              that.alertShow = false
              that.hasSubmit = false
            }, 3000)
          })
          .catch(() => {
            that.hasSubmit = false
          })
      } /*  */
    },

    // QQ群面板展示
    handleSubShow() {
      this.show = true
    },

    // QQ群面板隐藏
    handleSubHide() {
      this.show = false
      if (!this.menuListEnter && !this.menuEnter) {
        this.$refs.menuPopover.doClose()
      }
    },

    // 判断菜单隐藏时机
    handleHide() {
      if (this.show) {
        this.$refs.menuPopover.doShow()
        return
      }
      this.$refs.menuPopover.doClose()
    },

    // 菜单按钮首次展示增加监听
    handleShow() {
      if (!this.hasAddEventListener) {
        const menuDom = document.getElementsByClassName('item_box_menu')[0]
        const that = this
        menuDom.addEventListener('mouseenter', function() {
          that.menuEnter = true
        })
        menuDom.addEventListener('mouseleave', function() {
          that.menuEnter = false
        })
        const menuList = this.$refs.menuPopover.$children[0].$el
        // 处理从二维码直接移出的场景
        menuList.addEventListener('mouseenter', function() {
          that.menuListEnter = true
        })
        menuList.addEventListener('mouseleave', function() {
          that.menuListEnter = false
        })
        this.hasAddEventListener = true
      }
    },

    // qq群信息区域移入事件
    handleQrEnter() {
      this.qrEnter = true
    },

    // qq群信息区域移出事件
    handleQrLeave() {
      this.qrEnter = false
    },

    // 点击菜单
    handleClickMenu(index) {
      switch (this.menuList[index].type) {
        case 'survey':
          this.$trackSDK._trackEvent('全局', '单击“用户问卷icon”')
          window.open(this.menuList[index].url, '_blank')
          break
        case 'feedback':
          this.$trackSDK._trackEvent('全局', '单击“意见反馈icon”')
          this.handleClick()
          this.$refs.menuPopover.doClose()
          break
        case 'question':
          this.$trackSDK._trackEvent('全局', '单击“官方答疑icon”')
          break
        case 'handbook':
          this.$trackSDK._trackEvent('全局', '单击“使用指南icon”')
          this.$router.push({ name: 'manual' })
          break
        default:
          break
      }
    },

    // 点击下载按钮
    handleDownLoad() {
      this.$emit('downLoadClick')
    },

    // 获取qq信息
    getMyOrgInfo() {
      api.getMyOrgInfo().then(res => {
        this.QQinfo = res
      })
    }
  }
}
</script>

<style lang="scss">
.el-popover-scoped {
  min-width: 112px;
  left: unset !important;
  right: 65px;
  padding: 0 !important;
  border: 1px solid #f2f6ff !important;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;

  .popover-area {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .QR-code-area {
    padding: 6px 9px 9px;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    word-wrap: break-word;
    color: #2e2f33;
    border: 1px solid #f2f6ff;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    .QR-img {
      width: 112px;
      height: 112px;
      margin-bottom: 4px;
    }

    .name {
      margin-bottom: 2px;
    }
  }
}

.sec {
  right: 193px;
}

.el-menu-scoped {
  border-right: 0;
  border: 1px solid #dfe3eb;
  border-radius: 2px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.02), 0px 4px 24px rgba(0, 0, 0, 0.06);

  .el-menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    padding: 0 !important;

    .el-menu-item-area {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      padding: 0 15px 0 13px;
    }

    &:hover {
      .el-menu-item-area {
        .navinfo {
          color: #2962ff;
        }

        .ic_survey {
          background-image: url('~@/assets/feedback/ic_survey_hover.png');
        }

        .ic_feedback {
          background-image: url('~@/assets/feedback/ic_feedback_hover.png');
        }

        .ic_question {
          background-image: url('~@/assets/feedback/ic_question_hover.png');
        }

        .ic_handbook {
          background-image: url('~@/assets/feedback/ic_handbook_hover.png');
        }
      }
    }

    .menu-item-icon {
      width: 24px;
      height: 24px;
      background-size: cover;
    }

    .ic_survey {
      background-image: url('~@/assets/feedback/ic_survey.png');
    }

    .ic_feedback {
      background-image: url('~@/assets/feedback/ic_feedback.png');
    }

    .ic_question {
      background-image: url('~@/assets/feedback/ic_question.png');
    }

    .ic_handbook {
      background-image: url('~@/assets/feedback/ic_handbook.png');
    }

    .navinfo {
      font-size: 13px;
      line-height: 1;
      font-weight: 500;
      margin-left: 6px;
    }

    .navInline {
      display: inline-block;
    }
  }

  .el-menu-item-hover {
    background-color: #eef2ff;

    .el-menu-item-area {
      .navinfo {
        color: #2962ff;
      }

      .ic_question {
        background-image: url('~@/assets/feedback/ic_question_hover.png');
      }
    }
  }
}

.feedback_container {
  font-family: PingFangSC;

  .downLoadInfo {
    position: fixed;
    bottom: 112px;
    right: 24px;
    width: 40px;
    background-color: rgba(41, 98, 255, 0.86);
    // box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 0 0;
    cursor: pointer;
  }

  .item_box {
    width: 40px;
    height: 40px;
    background-size: 24px;
    background-position: center;

    &:hover {
      background-color: rgba(35, 84, 219, 0.86);
      background-size: 36px;
      background-position: center;
      border-radius: 4px;
    }
  }

  .download {
    width: 40px;
    height: 40px;
    background-size: 24px !important;
    background-position: 50% !important;
    @include commonBgImage('~@/assets/img/download_box__normal.png');
    &:hover {
      background-size: 36px !important;
      background-image: url('~@/assets/img/download_box_hover.png');
    }
  }

  .item_box_menu {
    position: fixed;
    z-index: 1000;
    bottom: 72px;
    right: 24px;
    width: 40px;
    height: 40px;
    background: url('../assets/feedback/ic_more.png') no-repeat;
    background-size: 24px;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    background-position: 50%;
    background-color: rgba(41, 98, 255, 0.86);
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    outline: none;

    &:hover {
      background-color: rgba(35, 84, 219, 0.86);
    }
  }

  .item_box_menu_fixed {
    border-radius: 0 0 4px 4px;
    border-top: 1px solid rgba(235, 236, 240, 0.2);
  }

  .item_box_menu_hover {
    background-color: rgba(35, 84, 219, 0.86);
  }

  .infomation {
    font-size: 40px;
    background: red;
  }

  .el-dialog__wrapper {
    background-color: rgba(41, 51, 89, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .el-dialog-scoped {
    width: 540px;
    height: 624px;
    border-radius: 8px;
    margin-top: 0 !important;
    margin-bottom: 0 !important;

    .el-icon-close {
      background-image: url('../assets/feedback/close.png');
      background-size: cover;
      width: 16px;
      height: 16px;
      color: transparent;

      &:hover {
        color: transparent;
      }
    }

    .el-dialog__header {
      padding: 0;
      z-index: 999;

      .el-dialog__headerbtn {
        z-index: 999;
      }
    }

    .el-dialog__body {
      padding-top: 32px;
      padding-left: 40px;
      padding-right: 0;
    }

    .el-tabs__header {
      margin-bottom: 25px;
    }

    .el-tabs__item {
      color: #909299;
      font-size: 20px;
      line-height: 28px;
      height: 28px;
      text-align: center;
      padding: 0;
      margin-right: 20px;
      margin-bottom: 12px;

      &.is-active {
        color: #2e2f33;
      }

      &:hover {
        color: #909299;
      }
    }

    .el-checkbox-button {
      margin-right: 20px;
      position: relative;

      &:nth-child(4),
      &:nth-child(8) {
        margin-right: 0;
      }

      .el-checkbox-button__inner:hover {
        border: 1px solid #2962ff;
        color: #2e2f33;
      }

      &.is-focus .el-checkbox-button__inner {
        border: 1px solid #ebecf0;

        &:hover {
          border: 1px solid #2962ff;
        }
      }

      &.is-checked .el-checkbox-button__inner {
        background-color: #fff;
        color: #2e2f33;
        border: 1px solid #2962ff;
      }
    }

    .is-checked:after {
      content: '';
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0;
      bottom: 20px;
      background-image: url('../assets/feedback/checked.png');
      background-size: cover;
    }

    .el-tabs__active-bar {
      background-color: transparent;
    }

    .el-tabs__nav-wrap:after {
      height: 1px;
      background-color: #ebecf0;
    }

    .description {
      height: 18px;
      line-height: 18px;
      font-size: 13px;
      color: #909299;
      margin-bottom: 20px;

      :first-child {
        color: #ff6583;
      }
    }

    .el-checkbox-button__inner {
      border: 1px solid #ebecf0;
      border-radius: 4px !important;
      margin-bottom: 20px;
      color: #2e2f33;
      font-size: 14px;
      width: 100px;
    }

    .textareaContainer {
      border: 1px solid #ebecf0;
      padding-top: 16px;
      padding-left: 16px;
      padding-right: 16px;
      margin-bottom: 10px;
      margin-top: 4px;
      height: 120px;
      width: 460px;
      box-sizing: border-box;
      border-radius: 4px;

      .el-input__count {
        bottom: -10px;
      }

      .el-textarea__inner {
        border: none;
      }
    }

    textarea {
      padding: 0 8px 0 0;
      border: none;
      height: 71px;
    }

    .screenshot {
      width: 460px;
      height: 128px;
      overflow: hidden;
      border-radius: 4px;
      border: 1px solid #ebecf0;
      cursor: zoom-in;
      position: relative;
      box-sizing: border-box;

      img {
        width: 100%;
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(41, 51, 89, 0.5);

        &:hover {
          background-color: rgba(41, 51, 89, 0.7);
        }
      }
    }

    .el-button {
      width: 104px;
      height: 32px;
      line-height: 1;
      padding: 0;
      float: right;
      margin-top: 20px;
      margin-right: 40px;

      &.is-round {
        padding: 0;
      }
    }

    .el-button--text {
      color: #2962ff !important;
      font-weight: 400 !important;
    }

    .el-button--primary {
      background-color: #2962ff !important;
      border: none !important;
    }

    .el-button--primary:hover {
      background-color: #2354db !important;
      border: none !important;
    }

    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
      background-color: #ebecf0 !important;
      color: #c4c6cc;
    }

    .adviceTextareaContainer {
      height: 156px;

      .el-input__count {
        bottom: -28px;
      }
    }

    .adviceTextarea textarea {
      height: 102px;
      padding-right: 8px;
    }

    .adviceScreenshot {
      height: 254px;
    }

    .browserTips {
      margin-top: 10px;
      font-size: 12px;
      color: #909299;

      span {
        color: #2e2f33;
      }
    }

    .focus-visible {
      border: 1px solid #ebecf0;
    }

    .error {
      color: #ff6583;
      font-size: 12px;
      line-height: 14px;
      height: 14px;
      position: relative;
      top: -6px;
    }
  }

  .alert {
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -120px;
    margin-top: -48px;
    width: 240px;
    height: 96px;
    border-radius: 4px;
    background-color: rgba(18, 27, 52, 0.8);
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .alertShow {
    display: flex;
  }

  .screenshotAlert {
    display: flex;
    width: 1280px;
    height: auto;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -640px;
    transform: translate(0, -50%);
    overflow: auto;
    z-index: 10;
    cursor: auto;
    border-radius: 8px;
    z-index: 1000;

    .close {
      background-image: url('../assets/feedback/close.png');
      background-size: cover;
      position: absolute;
      top: 14px;
      right: 12px;
      z-index: 11;
      cursor: pointer;
      width: 16px;
      height: 16px;
    }

    img {
      width: 100%;
    }
  }

  .screenshotAlertHide {
    display: none;
  }
}
</style>
